import Form from "../../form/Form";
import { notice } from "JS/utils/notice";

export default class UserDataForm {

    /**
     * @type {HTMLFormElement}
     */
    formElement;

    /**
     * @type {HTMLElement}
     */
    submitButton;

    /**
     * @type {Form}
     */
    form;

    isProcess = false;

    actions = {
        data: 'user_change_data',
        pass: 'user_change_password',
    };

    /**
     * @type {string}
     */
    get action() {
        if (!this.formElement) {
            return '';
        }

        const type = this.formElement.dataset.userForm;

        return this.actions[type] || '';
    }

    constructor(formElement) {
        if (!formElement) {
            return;
        }

        this.formElement = formElement;
        this.form = new Form(this.formElement);
        this.submitButton = this.formElement.querySelector('[type="submit"]');

        this.addListeners();

        this.addPasswordValidation();
    }

    addPasswordValidation() {
        if (!this.form) {
            return;
        }

        const fields = this.form.fields.filter(f => f.name.includes('new_password'));

        if (!fields.length) {
            return;
        }

        fields.forEach(f => f.validations.push('password'));
    }

    addListeners() {
        if (!this.form) {
            return;
        }

        this.form.on('submit', (data) => {
            this.onSubmit(data);
        });
    }

    onSubmit(data) {
        if (this.isProcess) {
            return;
        }
        
        const formData = this.getFormData(data);
        this.submitButton.classList.add('processing');

        this.isProcess = true;

        fetch(backendData.ajaxUrl, {
            method: 'POST',
            body: formData,
        })
            .then((resp) => resp.json())
            .then((response) => {
                
                if (!response.success) {
                    if (response.data?.message) {
                        this.onError(response.data?.message);
                    }
                    return;
                }

                if (response.data?.message) {
                    notice(response.data?.message);
                }
            })
            .catch((error) => {
                this.onError(error);
            })
            .finally(() => {
                this.submitButton.classList.remove('processing');
                this.isProcess = false;
            });
    }

    onError(error) {
        notice(error, 'error');
    }

    getFormData(data) {
        const formData = new FormData();
        const {
            change_data_nonce,
            change_password_nonce,
            ...otherData
        } = data;

        otherData.nonce = change_data_nonce || change_password_nonce;

        formData.append('action', this.action);
        formData.append('data', JSON.stringify(otherData));

        return formData;
    }
}
